/**
 * Lightweight API wrappers for the Quote Inbox. Used by both Customer and
 * Vendor inbox pages — the only difference is the URL prefix (`/vendor/` for
 * the supplier side). Both paths rely on the existing httpOnly auth cookies
 * (`tgm_customer_jwt` / `tgm_vendor_jwt`) so we don't pass tokens explicitly.
 */
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const cfg = { withCredentials: true };

const base = (role) => (role === 'vendor' ? '/vendor/quote-threads' : '/quote-threads');

export const inboxApi = {
  list: (role) => axios.get(`${API}${base(role)}`, cfg).then((r) => r.data),
  summary: (role) => axios.get(`${API}${base(role)}-summary`, cfg).then((r) => r.data),
  get: (role, id) => axios.get(`${API}${base(role)}/${id}`, cfg).then((r) => r.data),
  postMessage: (role, id, payload) =>
    axios.post(`${API}${base(role)}/${id}/messages`, payload, cfg).then((r) => r.data),
  markRead: (role, id) =>
    axios.post(`${API}${base(role)}/${id}/read`, {}, cfg).then((r) => r.data),
  uploadAttachment: (role, id, file) => {
    const fd = new FormData();
    fd.append('file', file);
    return axios.post(`${API}${base(role)}/${id}/attachment`, fd, {
      ...cfg,
      headers: { 'Content-Type': 'multipart/form-data' },
    }).then((r) => r.data);
  },
};

export const fmtRupee = (n) => `₹${Number(n || 0).toLocaleString('en-IN')}`;
export const fmtAgo = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return 'just now';
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 604800) return `${Math.floor(diff / 86400)}d ago`;
  return d.toLocaleDateString('en-IN', { day: 'numeric', month: 'short' });
};
